//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HButton from '../HButton'
import Wrapper from './Wrapper'
import {prefix} from '../../common/mixins'

export default {
  name: 'Confirm',
  components: {
    HButton,
    Wrapper,
  },
  mixins: [prefix],
  /* eslint-disable vue/require-default-prop */
  props: {
    title: String,
    content: String,
    noMask: Boolean,
    buttons: {
      type: Array,
      default: () => [
        {
          type: 'cancel',
          text: '取消',
          color: '',
          bgColor: '',
          alone: false,
        },
        {
          type: 'confirm',
          text: '确定',
          color: '',
          bgColor: '',
          alone: false,
        },
      ],
    },
  },
  /* eslint-enable */
  data () {
    return {
      show: false,
    }
  },
  computed: {
    firstButtonClass () {
      return this.buttons[0].alone ? 'alone half' : ''
    },
    secondButtonClass () {
      return this.buttons[1].alone ? 'alone half' : ''
    },
    firstButtonStyle () {
      return {
        color: this.buttons[0].color,
        backgroundColor: this.buttons[0].bgColor,
      }
    },
    secondButtonStyle () {
      return {
        color: this.buttons[1].color,
        backgroundColor: this.buttons[1].bgColor,
      }
    },
  },
  methods: {
    click (type, index) {
      // 如果type未指定，根据索引来确定点击的是取消还是确认按钮
      // 默认取消按钮放置在前，索引为0，确认按钮放置在后，索引为1
      if(!type) {
        if(index) {
          this.confirm()
        } else {
          this.cancel()
        }
      } else if(type === 'confirm') {
        this.confirm()
      } else {
        this.cancel()
      }
    },
    cancel () {
      if(!this.show) return
      this.$emit('on-cancel')
      this.hide()
    },
    confirm () {
      if(!this.show) return
      this.$emit('on-confirm')
      this.hide()
    },
    hide () {
      this.show = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Confirm.vue